import React from "react";
import Header from "@/components/th/Header";
import Menu from "@/components/th/Menu";
import Footer from "@/components/th/Footer";
import FloatingButton from "@/components/th/FloatingButton";
import ScrollToTopFab from "@/components/th/ScrollToTopFab";
import NewsListMain from "@/components/th/NewsListMain";
import Link from "next/link";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CircleIcon from "@mui/icons-material/Circle";
import SearchIcon from "@mui/icons-material/Search";
import Stack from "@mui/material/Stack";
import SAbout from "@/public/static/images/opacity_about.png";
import SPorcess from "@/public/static/images/opacity_process.png";
import SInstru from "@/public/static/images/opacity_instru.png";
import { getNewsTH } from "@/features/news";
import { appDispatch, appSelector } from "@/store/hooks";
import { wrapper } from "@/store/store";

const breadcrumbs = [
  <Link key="1" href="/th/">
    หน้าแรก
  </Link>,
  <Typography key="2">ข่าวสาร</Typography>,
];
function News({ initData }: any) {
  const dispatch = appDispatch();
  const { dataTH } = appSelector((state) => state.frontNews);
  const [searched, setSearched] = React.useState<string>("");
  const [myData, setMyData] = React.useState<any>(initData);

  const fetchSearch = async () => {
    const payload = await dispatch(getNewsTH(searched)).then((result: any) => {
      return result.payload;
    });
    return payload;
  };

  React.useEffect(() => {
    Promise.all([fetchSearch()]).then(([data]) => {
      setMyData(data);
    });
  }, [dispatch, searched]);
  return (
    <div className="wrapper">
      <Header />
      <Menu />
      <div className="coverMain">
        <div className="container">
          <div className="row">
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  noWrap
                  sx={{
                    mr: 2,
                    mb: 1,
                    fontFamily: "Prompt",
                    fontWeight: 800,
                    letterSpacing: ".1rem",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <CircleIcon
                    sx={{ mb: 1, mr: 2, fontSize: "18px", color: "#0179CC" }}
                  />
                  ข่าวสาร
                </Typography>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  className="breadcrumbs"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="d-flex justify-content-end">
                <FormControl
                  sx={{ m: 1, width: "30%" }}
                  className="search-news"
                  variant="outlined"
                >
                  <OutlinedInput
                    placeholder="Search..."
                    id="outlined-adornment-weight"
                    onChange={(e: React.ChangeEvent<any>) => {
                      e.preventDefault();
                      setSearched(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          type="button"
                          sx={{ p: "10px", color: "#0179cc" }}
                          aria-label="search"
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
            </div>
            <div className="col-12 py-3">
              <div className="sub-inner_headding">
                <h5 className="mb-0">ข่าวสาร</h5>
              </div>
            </div>
            <div className="col-12 mb-5">
              <NewsListMain data={myData} />
            </div>
          </div>
        </div>
      </div>

      <section className="sub-contact mt-5">
        <div className="sub-contact-inner">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0, sm: 0, md: 0 }}
            justifyContent="center"
            alignItems="center"
          >
            <Link href="/th/processusage">
              <div className="card card-subcontact bg-darkblue">
                <Image loading="lazy"
                  src={SPorcess}
                  alt="Process & Usage"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">แนะนำผลิตภัณฑ์</h1>
                </div>
              </div>
            </Link>
            <Link href="/th/instrument">
              <div className="card card-subcontact bg-blue">
                <Image loading="lazy"
                  src={SInstru}
                  alt="Instrument Overview"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">คำแนะนำเบื้องต้น</h1>
                </div>
              </div>
            </Link>
            <Link href="/th/aboutus">
              <div className="card card-subcontact bg-darkblue">
                <Image loading="lazy"
                  src={SAbout}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">ประวัติบริษัท</h1>
                </div>
              </div>
            </Link>
          </Stack>
        </div>
      </section>
      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}

export const getServerSideProps: any = wrapper.getServerSideProps(
  (store) => async () => {
    let data: any = await store.dispatch(getNewsTH(""));
    if (data.meta.requestStatus == "rejected") {
      data = { payload: [] };
    }
    return {
      props: {
        initData: data.payload,
      },
    };
  }
);
export default News;
